import { Text, View } from '@rbilabs/universal-components';

export const PriceAndCaloriesWrapper = View.withConfig({
  flexDirection: 'row',
  alignItems: 'center',
  flexWrap: 'nowrap',
});

export const Price = Text.withConfig({
  variant: 'copyTwo',
  fontWeight: 'bold',
});
